import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

const ListGroupItem = props => {
  const { tag: Tag, name, value, valueSize, label, subValue, ...attributes } = props;

  return (
    <Tag {...attributes} className="list-group-item">
      <Row className="w-100">
        <Col xs={12 - valueSize}>
          <label htmlFor={name}>{label}</label>
        </Col>
        <Col xs={valueSize}>
          <strong>{value}</strong>
          {subValue}
        </Col>
      </Row>
    </Tag>
  );
};

ListGroupItem.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subValue: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  valueSize: PropTypes.number,
};

ListGroupItem.defaultProps = {
  tag: 'div',
  valueSize: 8,
  subValue: null,
};

export default ListGroupItem;
